<template>
  <div>
    <h1 class="page-header">
      {{ $t('vehicleOperation.pageTitle') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('vehicleOperation.vehicle')
              }}</label>
              <ts-search-select
                v-model.number="model.vehicle_id"
                :options="vehicles"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('vehicle_id')">
                {{ errors.first('vehicle_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('vehicleOperation.zone') }}</label>
              <ts-search-select
                v-model.number="model.zone_id"
                :options="zones"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('zone_id')">
                {{ errors.first('zone_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('vehicleOperation.driver') }}</label>
              <ts-search-select
                v-model.number="model.driver_staff_id"
                :options="drivers"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('driver_staff_id')">
                {{ errors.first('driver_staff_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('vehicleOperation.driverAssistant') }}</label>
              <ts-search-select
                v-model.number="model.driver_assistance_id"
                :options="drivers"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('driver_assistance_id')">
                {{ errors.first('driver_assistance_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('vehicleOperation.date') }}</label>
              <ts-date-picker-input
                v-model="model.operation_date"
              ></ts-date-picker-input>
              <div class="validate" v-if="errors.has('operation_date')">
                {{ errors.first('operation_date') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'
import moment, { months } from 'moment'

export default {
  name: 'vehicleOperation-form',
  components: {
    DataTable
  },
  data () {
    return {
      model: {
        operation_id: '',
        vehicle_id: '',
        zone_id: '',
        driver_staff_id: '',
        driver_assistance_id: '',
        operation_date: moment().format('DD-MM-YYYY')
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('vehicleOperation', ['edit_data']),
    vehicles () {
      return this.$store.state.vehicleOperation.vehicles.map(el => ({
        value: el.vehicle_id,
        text: el.plate_no
      }))
    },
    zones () {
      return this.$store.state.vehicleOperation.zones.map(el => ({
        value: el.zone_id,
        text: el.zone_name_en
      }))
    },
    drivers () {
      return this.$store.state.vehicleOperation.employees.map(el => ({
        value: el.staff_id,
        text: el.name_en
      }))
    }
  },
  methods: {
    store () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('vehicleOperation/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('vehicleOperation/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel () {
      this.updating = false
      this.$store.commit('vehicleOperation/SET_EDIT_DATA', {})
      this.$router.push({ name: 'vehicle-operation' })
      this.clearInput()
    },
    clickBackURL () {
      this.$store.commit('vehicleOperation/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput () {
      this.model = {
        operation_id: '',
        vehicle_id: '',
        zone_id: '',
        driver_staff_id: '',
        driver_assistance_id: '',
        operation_date: moment().format('DD-MM-YYYY')
      }
    }
  },
  watch: {
    edit_data: {
      handler () {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('vehicleOperation/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
